// GENERATED FILE — do not edit.
// Source: packages/config/tokens/clavian.tokens.json (spec/BRAND.md §4–§5)
// Regenerate: pnpm generate (from the repository root)
/**
 * Token names and default values for the web kit.
 *
 * The values here are only the defaults; what a page renders is whatever `--clavian-*` resolves to
 * at that point in the tree. A brand configuration overrides them at runtime with
 * `applyBrandTokens()` (spec/03-architecture.md §12).
 */
/** Every colour token, in the order the brand guide states them. */
export const colorTokenNames = [
    "bg",
    "bg-sidebar",
    "surface-input",
    "surface",
    "surface-2",
    "surface-3",
    "surface-overlay",
    "ink",
    "muted",
    "subtle",
    "disabled",
    "line-subtle",
    "line",
    "line-emphasis",
    "line-strong",
    "nebula-1",
    "nebula-2",
    "nebula-3",
    "nebula-4",
    "ok-ink",
    "warn-ink",
    "danger-ink",
    "category-1",
    "category-2",
    "category-3",
    "category-4",
    "category-5",
    "category-6",
    "category-7",
    "category-8",
    "overlay",
    "tint-hover",
    "tint-active",
    "veil-1",
    "veil-2",
    "veil-3",
    "control",
    "control-selected",
    "art-scrim",
    "shadow-1",
    "shadow-2",
    "shadow-3",
    "shadow-card",
    "shadow-lift",
    "edge-light",
    "glass",
    "glow-focus",
    "glow-live",
    "glow-action",
    "glow-reward",
    "accent",
    "accent-hi",
    "accent-deep",
    "on-accent",
    "accent-ink",
    "focus",
    "surge",
    "on-surge",
    "reward",
    "reward-ink",
    "on-reward",
    "flare",
    "ok",
    "warn",
    "danger",
    "danger-hi",
    "on-ok",
    "on-warn",
    "on-danger",
    "chart-5",
    "accent-soft",
    "ok-bg",
    "ok-border",
    "warn-bg",
    "warn-border",
    "danger-bg",
    "danger-border",
    "info",
    "info-bg",
    "info-border",
    "session",
    "session-bg",
    "session-border",
    "chart-1",
    "chart-2",
    "chart-3",
    "chart-4",
    "chart-grid",
    "chart-axis",
    "surge-soft",
    "surge-border",
    "reward-soft",
    "reward-border",
];
/** Every scale token (space, radius, size, type, motion, focus, z). */
export const scaleTokenNames = [
    "space-0",
    "space-px",
    "space-0-5",
    "space-1",
    "space-2",
    "space-3",
    "space-4",
    "space-5",
    "space-6",
    "space-8",
    "space-10",
    "space-12",
    "space-16",
    "radius-xs",
    "radius-sm",
    "radius-md",
    "radius-lg",
    "radius-xl",
    "radius-2xl",
    "radius-full",
    "cut-sm",
    "cut-lg",
    "control-sm",
    "control-md",
    "control-lg",
    "icon-sm",
    "icon-md",
    "icon-lg",
    "target-min",
    "measure",
    "font-display",
    "font-wordmark",
    "font-body",
    "font-figures",
    "font-mono",
    "text-xs",
    "text-sm",
    "text-base",
    "text-lg",
    "text-xl",
    "text-2xl",
    "text-3xl",
    "text-4xl",
    "text-5xl",
    "leading-tight",
    "leading-snug",
    "leading-normal",
    "leading-relaxed",
    "tracking-tight",
    "tracking-tighter",
    "tracking-display",
    "tracking-normal",
    "tracking-label",
    "tracking-stamp",
    "weight-regular",
    "weight-medium",
    "weight-semibold",
    "weight-bold",
    "weight-extrabold",
    "width-condensed",
    "width-semicondensed",
    "motion-scale",
    "duration-fast",
    "duration-base",
    "duration-slow",
    "ease-standard",
    "ease-out",
    "ease-emphasized",
    "ease-enter",
    "ease-exit",
    "focus-width",
    "focus-offset",
    "z-base",
    "z-sticky",
    "z-dropdown",
    "z-overlay",
    "z-modal",
    "z-popover",
    "z-toast",
];
/** `--clavian-surface-2` for `surface-2`. */
export function cssVar(name) {
    return `--clavian-${name}`;
}
/** `var(--clavian-surface-2)` — for inline styles and canvas work. */
export function tokenValue(name) {
    return `var(${cssVar(name)})`;
}
/**
 * Where a set of token values has to be written for it to apply to a theme. applyBrandTokens()
 * builds its stylesheet from these, so a brand override lands on exactly the selectors the
 * defaults use — same specificity, later in the cascade, therefore it wins.
 */
export const themeRuleTargets = {
    shared: [{ media: null, selectors: [':root'] }],
    dark: [
        { media: null, selectors: [":root[data-theme=\"dark\"]", "[data-theme=\"dark\"]"] },
    ],
    light: [
        { media: "(prefers-color-scheme: light)", selectors: [":root:not([data-theme=\"dark\"])"] },
        { media: null, selectors: [":root[data-theme=\"light\"]", "[data-theme=\"light\"]"] },
    ],
};
export const themeModes = ["dark", "light"];
export const themeAccents = ["brand"];
export const themeDensities = ["comfortable", "kiosk", "touch"];
/** The default value of every scale token. */
export const scaleTokenDefaults = {
    "space-0": "0",
    "space-px": "1px",
    "space-0-5": "0.125rem",
    "space-1": "0.25rem",
    "space-2": "0.5rem",
    "space-3": "0.75rem",
    "space-4": "1rem",
    "space-5": "1.25rem",
    "space-6": "1.5rem",
    "space-8": "2rem",
    "space-10": "2.5rem",
    "space-12": "3rem",
    "space-16": "4rem",
    "radius-xs": "0.25rem",
    "radius-sm": "0.375rem",
    "radius-md": "0.5rem",
    "radius-lg": "0.75rem",
    "radius-xl": "1rem",
    "radius-2xl": "1.25rem",
    "radius-full": "9999px",
    "cut-sm": "0.625rem",
    "cut-lg": "1.75rem",
    "control-sm": "2rem",
    "control-md": "2.25rem",
    "control-lg": "2.75rem",
    "icon-sm": "1rem",
    "icon-md": "1.25rem",
    "icon-lg": "1.5rem",
    "target-min": "1.5rem",
    measure: "65ch",
    "font-display": "'Archivo Variable', 'Archivo', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
    "font-wordmark": "'Archivo Variable', 'Archivo', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
    "font-body": "'IBM Plex Sans Variable', 'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
    "font-figures": "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, 'SFMono-Regular', 'Cascadia Mono', Consolas, monospace",
    "font-mono": "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, 'SFMono-Regular', 'Cascadia Mono', 'Segoe UI Mono', Consolas, monospace",
    "text-xs": "0.75rem",
    "text-sm": "0.875rem",
    "text-base": "1rem",
    "text-lg": "1.125rem",
    "text-xl": "1.25rem",
    "text-2xl": "1.5rem",
    "text-3xl": "1.875rem",
    "text-4xl": "2.375rem",
    "text-5xl": "3rem",
    "leading-tight": "1.15",
    "leading-snug": "1.3",
    "leading-normal": "1.5",
    "leading-relaxed": "1.65",
    "tracking-tight": "-0.02em",
    "tracking-tighter": "-0.035em",
    "tracking-display": "-0.025em",
    "tracking-normal": "0em",
    "tracking-label": "0.08em",
    "tracking-stamp": "0.22em",
    "weight-regular": "400",
    "weight-medium": "500",
    "weight-semibold": "600",
    "weight-bold": "700",
    "weight-extrabold": "800",
    "width-condensed": "75%",
    "width-semicondensed": "87.5%",
    "motion-scale": "1",
    "duration-fast": "120ms",
    "duration-base": "180ms",
    "duration-slow": "260ms",
    "ease-standard": "cubic-bezier(0.2, 0, 0, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-emphasized": "cubic-bezier(0.3, 0, 0, 1.15)",
    "ease-enter": "cubic-bezier(0.16, 1, 0.3, 1)",
    "ease-exit": "cubic-bezier(0.4, 0, 1, 1)",
    "focus-width": "2px",
    "focus-offset": "2px",
    "z-base": "0",
    "z-sticky": "100",
    "z-dropdown": "1000",
    "z-overlay": "1100",
    "z-modal": "1200",
    "z-popover": "1300",
    "z-toast": "1400",
};
/** The resolved colour set for each theme (accent × mode) — the same values the CSS emits. */
export const themeColorDefaults = {
    brandDark: {
        bg: "#030409",
        "bg-sidebar": "#05060C",
        "surface-input": "#06070E",
        surface: "#080910",
        "surface-2": "#0D0E18",
        "surface-3": "#141523",
        "surface-overlay": "#10111C",
        ink: "#F2EEEA",
        muted: "#A6A3B3",
        subtle: "#817D90",
        disabled: "#4D4A5B",
        "line-subtle": "#12131E",
        line: "#202232",
        "line-emphasis": "#2C2F44",
        "line-strong": "#6F6C7E",
        "nebula-1": "rgba(32, 36, 88, 0.09)",
        "nebula-2": "rgba(52, 34, 78, 0.06)",
        "nebula-3": "rgba(30, 40, 96, 0.06)",
        "nebula-4": "rgba(48, 32, 70, 0.05)",
        "ok-ink": "#3DD68C",
        "warn-ink": "#FFC24A",
        "danger-ink": "#FF5C8A",
        "category-1": "#E393C8",
        "category-2": "#3AC5D8",
        "category-3": "#C4B254",
        "category-4": "#8CC379",
        "category-5": "#4EC9AD",
        "category-6": "#67BAF4",
        "category-7": "#9AABFB",
        "category-8": "#C59DEB",
        overlay: "rgba(1, 2, 5, 0.78)",
        "tint-hover": "rgba(242, 238, 234, 0.05)",
        "tint-active": "rgba(242, 238, 234, 0.09)",
        "veil-1": "rgba(242, 238, 234, 0.045)",
        "veil-2": "rgba(242, 238, 234, 0.075)",
        "veil-3": "rgba(242, 238, 234, 0.11)",
        control: "rgba(242, 238, 234, 0.11)",
        "control-selected": "#141523",
        "art-scrim": "rgba(3, 4, 9, 0.82)",
        "shadow-1": "0 1px 2px rgba(0, 0, 0, 0.5)",
        "shadow-2": "0 8px 24px rgba(0, 0, 0, 0.6), 0 0 0 1px #202232",
        "shadow-3": "0 16px 48px rgba(0, 0, 0, 0.7), 0 0 0 1px #202232",
        "shadow-card": "0 1px 2px rgba(0, 0, 0, 0.45), 0 12px 28px -18px rgba(0, 0, 0, 0.8)",
        "shadow-lift": "0 4px 12px rgba(0, 0, 0, 0.5), 0 24px 48px -20px rgba(0, 0, 0, 0.9)",
        "edge-light": "inset 0 1px 0 rgba(255, 255, 255, 0.05)",
        glass: "rgba(10, 11, 19, 0.72)",
        "glow-focus": "0 0 0 3px #030409, 0 0 0 5px #FF5A5F, 0 12px 34px -12px rgba(255, 90, 95, 0.55)",
        "glow-live": "0 6px 18px -10px rgba(255, 138, 61, 0.7)",
        "glow-action": "0 10px 30px -10px rgba(227, 25, 43, 0.65)",
        "glow-reward": "0 0 10px rgba(184, 50, 110, 0.5)",
        accent: "#E3192B",
        "accent-hi": "#C9142A",
        "accent-deep": "#B01226",
        "on-accent": "#FFFFFF",
        "accent-ink": "#FF5A5F",
        focus: "#FF5A5F",
        surge: "#FF8A3D",
        "on-surge": "#030409",
        reward: "#B8326E",
        "reward-ink": "#E05E92",
        "on-reward": "#FFFFFF",
        flare: "#FFD9B8",
        ok: "#3DD68C",
        warn: "#FFC24A",
        danger: "#FF5C8A",
        "danger-hi": "#FF8FB0",
        "on-ok": "#030409",
        "on-warn": "#030409",
        "on-danger": "#030409",
        "chart-5": "#8F8C9E",
        "accent-soft": "rgba(227, 25, 43, 0.16)",
        "ok-bg": "rgba(61, 214, 140, 0.12)",
        "ok-border": "rgba(61, 214, 140, 0.35)",
        "warn-bg": "rgba(255, 194, 74, 0.12)",
        "warn-border": "rgba(255, 194, 74, 0.35)",
        "danger-bg": "rgba(255, 92, 138, 0.12)",
        "danger-border": "rgba(255, 92, 138, 0.38)",
        info: "#FF5A5F",
        "info-bg": "rgba(227, 25, 43, 0.16)",
        "info-border": "rgba(255, 90, 95, 0.4)",
        session: "#FF8A3D",
        "session-bg": "rgba(255, 138, 61, 0.14)",
        "session-border": "rgba(255, 138, 61, 0.45)",
        "chart-1": "#E3192B",
        "chart-2": "#3DD68C",
        "chart-3": "#FFC24A",
        "chart-4": "#FF5C8A",
        "chart-grid": "#12131E",
        "chart-axis": "#817D90",
        "surge-soft": "rgba(255, 138, 61, 0.14)",
        "surge-border": "rgba(255, 138, 61, 0.45)",
        "reward-soft": "rgba(184, 50, 110, 0.16)",
        "reward-border": "rgba(184, 50, 110, 0.45)",
    },
    brandLight: {
        bg: "#F7F5F2",
        "bg-sidebar": "#EFECE8",
        "surface-input": "#FFFFFF",
        surface: "#FFFFFF",
        "surface-2": "#F3F0EC",
        "surface-3": "#E7E2DC",
        "surface-overlay": "#FFFFFF",
        ink: "#16141D",
        muted: "#4E4B5B",
        subtle: "#625F6F",
        disabled: "#A8A4AF",
        "line-subtle": "#ECE8E3",
        line: "#E2DDD7",
        "line-emphasis": "#CBC5BE",
        "line-strong": "#857F79",
        "nebula-1": "rgba(32, 36, 88, 0)",
        "nebula-2": "rgba(52, 34, 78, 0)",
        "nebula-3": "rgba(30, 40, 96, 0)",
        "nebula-4": "rgba(48, 32, 70, 0)",
        "ok-ink": "#06734F",
        "warn-ink": "#8F4E06",
        "danger-ink": "#B31451",
        "category-1": "#A2568A",
        "category-2": "#008799",
        "category-3": "#867500",
        "category-4": "#4F853B",
        "category-5": "#218672",
        "category-6": "#1D7CB4",
        "category-7": "#5F6DBA",
        "category-8": "#8760AB",
        overlay: "rgba(22, 20, 29, 0.42)",
        "tint-hover": "rgba(22, 20, 29, 0.04)",
        "tint-active": "rgba(22, 20, 29, 0.07)",
        "veil-1": "rgba(22, 20, 29, 0.035)",
        "veil-2": "rgba(22, 20, 29, 0.06)",
        "veil-3": "rgba(22, 20, 29, 0.09)",
        control: "#FFFFFF",
        "control-selected": "#FFFFFF",
        "art-scrim": "rgba(247, 245, 242, 0.86)",
        "shadow-1": "0 1px 2px rgba(36, 26, 20, 0.08)",
        "shadow-2": "0 8px 24px rgba(36, 26, 20, 0.12), 0 0 0 1px #E2DDD7",
        "shadow-3": "0 18px 48px rgba(36, 26, 20, 0.18), 0 0 0 1px #E2DDD7",
        "shadow-card": "0 1px 2px rgba(36, 26, 20, 0.06), 0 12px 28px -18px rgba(36, 26, 20, 0.24)",
        "shadow-lift": "0 4px 12px rgba(36, 26, 20, 0.08), 0 24px 48px -20px rgba(36, 26, 20, 0.32)",
        "edge-light": "0 0 0 1px rgba(36, 26, 20, 0.07), 0 1px 2px rgba(36, 26, 20, 0.05)",
        glass: "rgba(255, 255, 255, 0.9)",
        "glow-focus": "0 0 0 3px #F7F5F2, 0 0 0 5px #B00A1D, 0 12px 34px -12px rgba(176, 10, 29, 0.35)",
        "glow-live": "0 6px 18px -10px rgba(173, 75, 0, 0.4)",
        "glow-action": "0 10px 30px -12px rgba(227, 25, 43, 0.45)",
        "glow-reward": "0 0 10px rgba(184, 50, 110, 0.3)",
        accent: "#E3192B",
        "accent-hi": "#C9142A",
        "accent-deep": "#B01226",
        "on-accent": "#FFFFFF",
        "accent-ink": "#B00A1D",
        focus: "#B00A1D",
        surge: "#AD4B00",
        "on-surge": "#FFFFFF",
        reward: "#B8326E",
        "reward-ink": "#9E2A5E",
        "on-reward": "#FFFFFF",
        flare: "#FFD9B8",
        ok: "#13A26E",
        warn: "#D98A06",
        danger: "#D73F6D",
        "danger-hi": "#EC537F",
        "on-ok": "#030409",
        "on-warn": "#030409",
        "on-danger": "#030409",
        "chart-5": "#857F79",
        "accent-soft": "rgba(227, 25, 43, 0.16)",
        "ok-bg": "rgba(19, 162, 110, 0.12)",
        "ok-border": "rgba(19, 162, 110, 0.35)",
        "warn-bg": "rgba(217, 138, 6, 0.12)",
        "warn-border": "rgba(217, 138, 6, 0.35)",
        "danger-bg": "rgba(215, 63, 109, 0.12)",
        "danger-border": "rgba(215, 63, 109, 0.38)",
        info: "#B00A1D",
        "info-bg": "rgba(227, 25, 43, 0.16)",
        "info-border": "rgba(176, 10, 29, 0.4)",
        session: "#AD4B00",
        "session-bg": "rgba(173, 75, 0, 0.14)",
        "session-border": "rgba(173, 75, 0, 0.45)",
        "chart-1": "#E3192B",
        "chart-2": "#13A26E",
        "chart-3": "#D98A06",
        "chart-4": "#D73F6D",
        "chart-grid": "#ECE8E3",
        "chart-axis": "#625F6F",
        "surge-soft": "rgba(173, 75, 0, 0.14)",
        "surge-border": "rgba(173, 75, 0, 0.45)",
        "reward-soft": "rgba(184, 50, 110, 0.16)",
        "reward-border": "rgba(184, 50, 110, 0.45)",
    },
};
/** The gradient tokens (BRAND.md §4, ADR-0060): only for brand moments, never a button or text. */
export const gradientTokenNames = [
    "gradient-brand",
];
/** Each gradient resolved for each theme — the same values the CSS composes from the colour tokens. */
export const themeGradientDefaults = {
    brandDark: {
        "gradient-brand": "linear-gradient(90deg, #B8326E 0%, #E3192B 55%, #FF8A3D 100%)",
    },
    brandLight: {
        "gradient-brand": "linear-gradient(90deg, #B8326E 0%, #E3192B 55%, #AD4B00 100%)",
    },
};
//# sourceMappingURL=tokens.generated.js.map